module.exports = __webpack_public_path__ + "img/filter-coach-example.67972ccd.png";